import { all, put, race, take, takeLatest } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { error } from '../../../../../../../../services/toastr'

import { LOCALE_PREFIX, LOAD_GROUPS, LOAD_GROUPS_REQUEST } from './constants'

import { loadGroupsRequest, groupsLoaded } from './actions'

const LOAD_GROUPS_REQUEST_SUCCESS = `${LOAD_GROUPS_REQUEST}_${SUCCESS}`
const LOAD_GROUPS_REQUEST_FAILED = `${LOAD_GROUPS_REQUEST}_${FAILED}`

function* loadGroupsCallSaga() {
    yield put(loadGroupsRequest())

    const result = yield race({
        success: take(LOAD_GROUPS_REQUEST_SUCCESS),
        failed: take(LOAD_GROUPS_REQUEST_FAILED),
    })

    if (!result.failed) {
        const groups = _.get(result, 'success.payload.response.body', [])

        yield put(groupsLoaded(groups))
    } else {
        error({
            id: `${LOCALE_PREFIX}.getError`,
        })
    }

    return null
}

export default function* groupsContentSaga() {
    yield all([takeLatest(LOAD_GROUPS, loadGroupsCallSaga)])
}
